import {
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { jiraApiRef, JiraAPI } from '@roadiehq/backstage-plugin-jira';

/**
 * Jira API registration.
 *
 * The Jira plugin has no alpha export, so the API factory that the legacy
 * plugin normally registers is missing. We re-create it here as an
 * `ApiBlueprint` so that `useApi(jiraApiRef)` resolves at runtime.
 */
const jiraApi = ApiBlueprint.make({
  name: 'jira',
  params: defineParams =>
    defineParams({
      api: jiraApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) =>
        new JiraAPI({ discoveryApi, configApi, fetchApi }),
    }),
});

export const jiraApiModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [jiraApi],
});
